import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../../data/Constants';
import { getMarketAssociation } from '../../../store/states/MarketSlice';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const MarketAssociation = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.MarketAssociationKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.marketAssociation')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.MarketAssociation}
        getDataList={getMarketAssociation}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
